var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-column-form" }, [
    _c(
      "div",
      { staticClass: "form" },
      [
        _c(
          "div",
          { staticClass: "field" },
          [
            _c("label", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("wp.columnType"))),
            ]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                attrs: { value: _vm.columnType },
                on: { change: _vm.handleColumnTypeChange },
              },
              _vm._l(_vm.getAllowedColumns(), function (col) {
                return _c(
                  "a-select-option",
                  { key: col.id, attrs: { value: col.id } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(col.title) +
                        "\n                "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.columnType === "custom"
          ? _c(
              "div",
              { staticClass: "field" },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("wp.columnName"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-input",
                  {
                    ref: "userNameInput",
                    attrs: {
                      placeholder: _vm.$t("whatsapp.typeColumnName"),
                      required: true,
                    },
                    model: {
                      value: _vm.columnName,
                      callback: function ($$v) {
                        _vm.columnName = $$v
                      },
                      expression: "columnName",
                    },
                  },
                  [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          slot: "suffix",
                          title: _vm.$t("whatsapp.columnNameInfo"),
                        },
                        slot: "suffix",
                      },
                      [
                        _c("a-icon", {
                          staticStyle: { color: "rgba(0, 0, 0, 0.45)" },
                          attrs: { type: "info-circle" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "field" },
          [
            _c("label", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("wp.defaultValue"))),
            ]),
            _vm._v(" "),
            _c(
              "a-input",
              {
                ref: "userNameInput",
                attrs: { placeholder: _vm.$t("wp.defaultValue") },
                model: {
                  value: _vm.defaultValue,
                  callback: function ($$v) {
                    _vm.defaultValue = $$v
                  },
                  expression: "defaultValue",
                },
              },
              [
                _c(
                  "a-tooltip",
                  {
                    attrs: {
                      slot: "suffix",
                      title: _vm.$t("wp.setDefaultValue"),
                    },
                    slot: "suffix",
                  },
                  [
                    _c("a-icon", {
                      staticStyle: { color: "rgba(0, 0, 0, 0.45)" },
                      attrs: { type: "info-circle" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("a-divider"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c("a-button", { on: { click: _vm.cancel } }, [
              _vm._v(_vm._s(_vm.$t("wp.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "primary", disabled: !_vm.isValid() },
                on: { click: _vm.save },
              },
              [_vm._v(" " + _vm._s(_vm.$t("wp.save")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }